var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChipStatus, } from '../../models';
import { classNames } from '../../utils/style-class.utils';
import * as styles from './header-card.styles';
export var HeaderCard = function (_a) {
    var slide = _a.slide, className = _a.className;
    var getChipStatusText = function (status) {
        switch (status) {
            case 1:
                return 'Available now';
            case 2:
                return 'Comning soon';
            default:
                return '';
        }
    };
    var getChipStatusColourPalette = function (status) {
        switch (status) {
            case ChipStatus.Available:
                return {
                    textColour: 'white',
                    borderColour: 'successMain',
                    backgroundColour: 'successMain',
                };
            case ChipStatus.ComingSoon:
            default:
                return {
                    textColour: 'alertMain',
                    borderColour: 'alertMain',
                    backgroundColour: 'white',
                };
        }
    };
    var palette = getChipStatusColourPalette(slide.status);
    return (_jsxs("div", __assign({ className: classNames(styles.card, className) }, { children: [_jsx("div", __assign({ className: styles.imageWrapper }, { children: _jsx("img", { src: slide.image, style: { width: '100%' }, className: styles.cardBanner }) })), _jsxs("div", __assign({ className: styles.cardInformation }, { children: [_jsx("div", __assign({ className: styles.cardTitle }, { children: slide.title })), _jsx("div", __assign({ className: styles.cardText }, { children: slide.text }))] }))] })));
};
export default HeaderCard;
//# sourceMappingURL=header-card.js.map